import { FilesUploader } from "components";
import { MediaDirectoryKeys, MediaType } from "constants/enums";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormField, MultipleMediaFilesPicker } from "ui";

import { ProductFormValues } from "../ProductDetailsForm.types";

export const RealVideoBlock = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<ProductFormValues>();

  const {
    fields: mediaFiles,
    append: appendMediaFile,
    remove: removeMediaFile
  } = useFieldArray({
    control,
    name: "realVideo"
  });

  return (
    <FormField label={t("Real video")}>
      <Controller
        control={control}
        name="realVideo"
        render={({ fieldState: { error } }) => (
          <FormField errorMessage={error?.message}>
            <FilesUploader
              onSuccessUploading={appendMediaFile}
              uploadDirectoryKey={MediaDirectoryKeys.ProductVariant}
            >
              {(uploaderProps) => (
                <MultipleMediaFilesPicker
                  label={t("Upload raw, unedited footage of the actual item")}
                  allowedMediaTypes={[MediaType.VIDEO]}
                  size="lg"
                  {...uploaderProps}
                  value={mediaFiles}
                  filesLimit={1}
                  onDeleteMediaFile={removeMediaFile}
                />
              )}
            </FilesUploader>
          </FormField>
        )}
      />
    </FormField>
  );
};
